import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BaseService } from '@library-shared/base/base.service';
import { Observable } from 'rxjs';
import { ApiReturn } from '@library-shared/models/api-return';
import { ApiRecordReturn } from '@library-shared/models/api-record-return';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class JobService extends BaseService {
    private apiURL = environment.apiURL + '/api/job'; // URL to web api

    TrafficPayToSureBank_Job(): Observable<ApiReturn> {
        const url = `${this.apiURL}/TrafficPayToSureBank_Job`;
        const request = {};
        return this.http.get<ApiReturn>(url, this.requestOptions).pipe(catchError((e) => this.handleError(e)));
    }

    SureBankToTrafficPay_Job(): Observable<ApiReturn> {
        const url = `${this.apiURL}/SureBankToTrafficPay_Job`;
        const request = {};
        return this.http.get<ApiReturn>(url, this.requestOptions).pipe(catchError((e) => this.handleError(e)));
    }

    TrafficPayVoidRefund_Job(): Observable<ApiReturn> {
        const url = `${this.apiURL}/TrafficPayVoidRefund_Job`;
        const request = {};
        return this.http.get<ApiReturn>(url, this.requestOptions).pipe(catchError((e) => this.handleError(e)));
    }

    JobQueue_Job(): Observable<ApiReturn> {
        const url = `${this.apiURL}/JobQueue_Job`;
        const request = {};
        return this.http.get<ApiReturn>(url, this.requestOptions).pipe(catchError((e) => this.handleError(e)));
    }

    TrafficaPayNewPayments_Job(): Observable<ApiReturn> {
        const url = `${this.apiURL}/TrafficaPayNewPayments_Job`;
        const request = {};
        return this.http.get<ApiReturn>(url, this.requestOptions).pipe(catchError((e) => this.handleError(e)));
    }
}
